export default __webpack_public_path__ + "static/media/3d-glasses-4.18658d70.png";